"use client";

import dynamic from "next/dynamic";
const GlobalTrainerRegistrationForm = dynamic(
  () =>
    import("@/components/forms/global-trainer-registration-form").then(
      (mod) => mod.GlobalTrainerRegistrationForm
    ),
  { ssr: false }
);
import { Section } from "@/components/section";
import { Suspense } from "react";

type AnOverviewProps = {
  section: PageSections;
  data?: {
    heading: string;
    description: string;
  };
};
const AnOverview = ({ section }: AnOverviewProps) => {
  return (
    <Section className={section.sectionClass} id={section.sectionId}>
      <Suspense>
        <GlobalTrainerRegistrationForm />
      </Suspense>
    </Section>
  );
};

export default AnOverview;
